// Vidéos de la maquette « 30 sept » :
// - modale vidéo (templates/components/anima/modale-video.twig) ouverte par tout élément
//   `data-anima-video="<url>"` (option `data-anima-video-poster`), lecture avec le son et les
//   contrôles ; Échap, voile, bouton et piège du focus ; source retirée à la fermeture ;
// - aperçus muets en boucle `video[data-anima-apercu]` : source chargée à l'approche
//   (`data-src`), lecture seulement quand 40 % de la vidéo est à l'écran, pause sinon ; jamais
//   lancés si l'utilisateur réduit les animations ou économise ses données (poster seul).

import {
  closeDialog,
  openDialog,
  reducedMotion,
  trapFocus
} from './dialogue-anima'

const PREVIEW_VISIBLE = 0.4 // part visible au-delà de laquelle l'aperçu tourne
const PREVIEW_MARGIN = '200px 0px' // chargement de la source à l'approche

const saveData = () => Boolean(navigator.connection && navigator.connection.saveData)

const initApercus = () => {
  const videos = [...document.querySelectorAll('video[data-anima-apercu]')]
  if (!videos.length || reducedMotion() || saveData() || !('IntersectionObserver' in window)) {
    return
  }
  const load = (video) => {
    if (video.dataset.src && !video.src) {
      video.src = video.dataset.src
    }
  }
  const near = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        load(entry.target)
        near.unobserve(entry.target)
      }
    })
  }, {
    rootMargin: PREVIEW_MARGIN
  })
  const seen = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const video = entry.target
      if (entry.intersectionRatio >= PREVIEW_VISIBLE && !document.documentElement.classList.contains('anima-modale-open')) {
        load(video)
        video.muted = true
        video.play().catch(() => null)
      } else {
        video.pause()
      }
    })
  }, {
    threshold: [0, PREVIEW_VISIBLE]
  })
  videos.forEach((video) => {
    near.observe(video)
    seen.observe(video)
  })
}

const initModale = () => {
  const modal = document.querySelector('[data-anima-video-modal]')
  if (!modal) {
    return
  }
  const player = modal.querySelector('video')
  let opener = null
  let paused = []

  const open = (trigger) => {
    opener = trigger
    // Les aperçus qui tournaient reprennent à la fermeture (maquette, QA3 E11).
    paused = [...document.querySelectorAll('video[data-anima-apercu]')].filter((v) => !v.paused)
    paused.forEach((v) => v.pause())
    player.poster = trigger.dataset.animaVideoPoster || ''
    player.src = trigger.dataset.animaVideo
    openDialog(modal)
    player.focus({
      preventScroll: true
    })
    player.play().catch(() => null)
  }

  const close = () => {
    if (modal.hidden) {
      return
    }
    player.pause()
    closeDialog(modal, () => {
      player.removeAttribute('src')
      player.load()
      if (!reducedMotion()) {
        paused.forEach((v) => v.play().catch(() => null))
      }
      paused = []
      if (opener) {
        opener.focus({
          preventScroll: true
        })
      }
    })
  }

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-anima-video]')
    if (trigger && trigger.dataset.animaVideo) {
      e.preventDefault()
      open(trigger)
      return
    }
    if (e.target.closest('[data-anima-video-close]')) {
      close()
    }
  })

  document.addEventListener('keydown', (e) => {
    if (modal.hidden) {
      return
    }
    if (e.key === 'Escape') {
      close()
    }
    trapFocus(modal, e)
  })
}

const init = () => {
  initApercus()
  initModale()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}
